import React from "react"
import {
  useIntl,
  IntlContextConsumer,
  changeLocale,
  Link,
} from "gatsby-plugin-intl"

const languageName = {
  en: "English",
  fr: "Français",
  it: "Italiano",
  es: "Español",
  bg: "български",
}

export default function TopRightNav() {
  const intl = useIntl()
  return (
    <div className="topRightNav">
      <div className="contactUs">
        <Link to="/contact">{intl.formatMessage({ id: "menu16" })}</Link>
      </div>
      <nav
        className="langSwitcher"
        aria-label={intl.formatMessage({ id: "accessibility2" })}
      >
        <ul>
          <li className="langSwitcher--currentLang">
            <Link to="/" aria-haspopup="true">
              {intl.locale} &#9662;
            </Link>
            <ul className="langSwitcher--submenu">
              <ul
                className="langSwitcher--dropdown"
                aria-label={intl.formatMessage({ id: "accessibility1" })}
              >
                <IntlContextConsumer>
                  {({ languages, language: currentLocale }) =>
                    languages.map((language, index) => (
                      <li key={index}>
                        <button
                          onClick={() => changeLocale(language)}
                          style={{
                            color:
                              currentLocale === language ? `#999` : `initial`,
                          }}
                        >
                          {languageName[language]}
                        </button>
                      </li>
                    ))
                  }
                </IntlContextConsumer>
              </ul>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  )
}
